import * as actionTypes from '../Actions/RegistrationActionTypes';

const axiosPayLoad = {
  payload: null
};
const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.VALIDATE_REGISTRATION:
      return { ...state, validateRegistration: action.validateRegistration };
    case actionTypes.REGISTRATION_OPTIONS:
      return { ...state, registrationOptions: action.registrationOptions };
    case actionTypes.VALIDATE_REGISTRATION_OPTIONS:
      return { ...state, validateRegistrationOptions: action.validateRegistrationOptions };
    case actionTypes.VERIFY_VERIFICATION_CODE:
      return { ...state, verifyVerificationCode: action.verifyVerificationCode };
    case actionTypes.RESEND_VERIFICATION_CODE:
      return { ...state, resendVerificationCode: action.resendVerificationCode };
    case actionTypes.RESEND_EMAIL:
      return { ...state, resendEmail: action.resendEmail };
    case actionTypes.RESET_REGISTRATION_DATA:
      return { ...state, [action.key]: '' };
    default: return state;
  }
};

export default reducer;
